import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack } from '../../utils/index.js';
import lch2lab from './lch2lab.js';
import lab2rgb from '../lab/lab2rgb.js';
var lch2rgb = function lch2rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args = unpack(args, 'lch');
  var _args = args,
    _args2 = _slicedToArray(_args, 3),
    l = _args2[0],
    c = _args2[1],
    h = _args2[2];
  var _lch2lab = lch2lab(l, c, h),
    _lch2lab2 = _slicedToArray(_lch2lab, 3),
    L = _lch2lab2[0],
    a = _lch2lab2[1],
    b_ = _lch2lab2[2];
  var _lab2rgb = lab2rgb(L, a, b_),
    _lab2rgb2 = _slicedToArray(_lab2rgb, 3),
    r = _lab2rgb2[0],
    g = _lab2rgb2[1],
    b = _lab2rgb2[2];
  return [r, g, b, args.length > 3 ? args[3] : 1];
};
export default lch2rgb;